import { Component, Input } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { OilCollectionModel } from '../../../../../models/customers/oil-collection.model';
import { OilCollectionService } from '../../../../../services/customers/oil-collection.service';

@Component({
    selector: 'app-oil-collection-details',
    templateUrl: './oil-collection-details.component.html',
    styleUrls: ['./oil-collection-details.component.scss'],
    standalone: false
})
export class OilCollectionDetailsComponent {
  @Input() oilCollection!: OilCollectionModel;

  isEditing = false;
  loading = false;
  editGallons: any;
  editDate: string = '';
  editNotes: string = '';

  constructor(
    public activeModal: NgbActiveModal,
    private oilCollectionService: OilCollectionService,
    private toastr: ToastrService
  ) { }

  formatObservation(topic: string): string {
    return topic ? topic.replace(/_/g, ' ') : '';
  }

  startEdit() {
    this.editGallons = this.oilCollection.gallons || 0;
    this.editDate = this.oilCollection.created_at ? this.oilCollection.created_at.split('T')[0] : '';
    this.editNotes = this.oilCollection.observations?.manual_notes || '';
    this.isEditing = true;
  }

  cancelEdit() {
    this.isEditing = false;
  }

  save() {
    if (!this.editDate || this.editGallons === null || this.editGallons === undefined) {
      this.toastr.error('Please complete the required fields');
      return;
    }

    this.loading = true;
    const payload = {
      created_at: this.editDate,
      gallons: this.editGallons,
      notes: this.editNotes
    };

    this.oilCollectionService.update(payload, this.oilCollection._id).subscribe(
      (res: any) => {
        this.loading = false;
        this.toastr.success(res.msg || 'Collection updated successfully');
        this.activeModal.close(true);
      },
      (err: any) => {
        console.error(err);
        this.loading = false;
        this.toastr.error('Server Error');
      }
    );
  }
}
